import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo_curisall_white_160x40.svg'


const _withScopeId = n => (_pushScopeId("data-v-2ae1fb24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "home" }
const _hoisted_2 = { class: "wrapper-max" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "큐리스올 로고"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "hidden" }, "전체 메뉴", -1))
const _hoisted_5 = { id: "gnb" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "depth2"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { id: "util" }
const _hoisted_10 = {
  key: 0,
  class: "util-depth2"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "hidden" }, "전체화면 레이어", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "wrapper-max" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "hidden" }, "퀵 메뉴", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "메인", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "의료진", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "환자", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "상담", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "결제", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "고객센터", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "설정", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "hidden" }, "본문", -1))
const _hoisted_23 = { id: "content" }
const _hoisted_24 = { class: "content-header" }
const _hoisted_25 = {
  key: 0,
  class: "content-header-wrap"
}
const _hoisted_26 = { class: "calendar-all" }
const _hoisted_27 = {
  key: 1,
  class: "sub-menu"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "hidden" }, "하위 메뉴", -1))
const _hoisted_29 = { class: "hidden" }
const _hoisted_30 = {
  key: 0,
  class: "depth2"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "body-title"
}
const _hoisted_33 = { class: "router-view" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", null, [
  /*#__PURE__*/_createElementVNode("address", null, "Copyright © CURIS ALL. All Rights Reserved.")
], -1))
const _hoisted_35 = {
  key: 0,
  class: "currentPopup"
}

import { onMounted, ref, computed, onUpdated } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import LoadingLayer from '@/components/layer/LoadingLayer.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter();
const store = useStore();
const Menu = store.state.moduleMenu;
/**** data -------------------- */
var isOn_scroll = ref(false);
var isOn_gnb = ref(false);
var isOn_qnb = ref(false);
var isOn_util = ref(false);
var utilDepth2_1 = ref('로그아웃');
var isOn_auth = ref(true);

const gnbStyles = computed(() => Menu.gnbStyles);
const menus = computed(() => Menu.menus);
const menu = computed(() => Menu.menu);

var bodyTitle = computed(() => Menu.bodyTitle);
var bodyDesc = computed(() => Menu.bodyDesc);

var leftNum = computed(() => {
  var i = store.state.moduleMenu.menus[0];
  var num = 0;
  if (i == 1) num = 80;
  if (i == 2) num = 280;
  if (i == 3) num = 460;
  if (i == 4) num = 660;
  if (i == 5) num = 680;
  if (i == 6) num = 1000;
  return `${num.toString()}px`;
});
var todayStr = ref('');
/**** capsules ---------------- */
var boolGnbQnb = (g: boolean, q: boolean, u: boolean) => {
  isOn_gnb.value = g;
  isOn_qnb.value = q;
  isOn_util.value = u;
};
var resetStyle_gnb = () => {
  for (let i = 0; i < store.state.moduleMenu.gnbStyles.length; i++) {
    store.state.moduleMenu.gnbStyles[i] = false;
  }
};
var onStyle_gnbDepth1 = (d1: number): boolean => {
  if (store.state.moduleMenu.gnbStyles[d1]) {
    return (store.state.moduleMenu.gnbStyles[d1] = false);
  } else {
    return (store.state.moduleMenu.gnbStyles[d1] = true);
  }
};
var isOn_loadingLayer = ref(false);
/**** methods ----------------- */
const onClick_logo = () => {
  boolGnbQnb(false, false, false);
  resetStyle_gnb();
  router.push({ name: store.state.moduleMenu.menu[0].depth2[0].routerName });
};
const onClick_gnbDepth1 = async (d1: number): Promise<void> => {
  if (isOn_gnb.value) {
    boolGnbQnb(false, false, false);
    resetStyle_gnb();
  } else {
    boolGnbQnb(true, false, false);
    resetStyle_gnb();
    onStyle_gnbDepth1(d1);
  }
};
const onClick_gnbDepth2 = (d1: number, d2: number): void => {
  boolGnbQnb(true, false, false);
  resetStyle_gnb();
  onStyle_gnbDepth1(d1);
  isOn_gnb.value = false;
};
const onClick_qnbDepth1 = (d1: number): void => {
  boolGnbQnb(false, true, false);
  resetStyle_gnb();
  onStyle_gnbDepth1(d1);
  router.push({ name: store.state.moduleMenu.menu[d1].depth2[0].routerName });
};
const onClick_qnbDepth2 = (d1: number, d2: number): void => {
  boolGnbQnb(false, true, false);
  resetStyle_gnb();
  onStyle_gnbDepth1(d1);
};
const onClick_dimClear = () => {
  boolGnbQnb(false, false, false);
  resetStyle_gnb();
  store.state.moduleMenu.gnbStyles[store.state.moduleMenu.menus[0]] = true;
};
const onClick_util = () => {
  if (isOn_util.value) {
    boolGnbQnb(false, false, false);
  } else {
    boolGnbQnb(false, false, true);
  }
};
const onClick_utilDepth2_1 = () => {
  boolGnbQnb(false, false, false);
  store.dispatch('moduleAuth/logout', { root: true });
  router.replace({ name: 'Login' });
};
const offLoadingLayer = (param: string): void => {
  isOn_loadingLayer.value = false;
};
const setTodayStr = async () => {
  let today, year, month, date: string | number;
  await (() => {
    today = new Date();
    year = today.getFullYear();
    month = today.getMonth() + 1;
    if (month < 10) {
      month = `0${month}`;
    }
    date = today.getDate();
    if (date < 10) {
      date = `0${date}`;
    }
  })();
  todayStr.value = `오늘, ${year}-${month}-${date}`;
};
const doOnStyle_qnb = async () => {
  window.addEventListener('scroll', () => {
    if (!isOn_scroll.value) {
      isOn_scroll.value = true;
    }
    setTimeout(() => {
      if (isOn_scroll.value) {
        isOn_scroll.value = false;
      }
    }, 600);
  });
};
/**** content -----------------
 *
 * 홈
 * /
 * /
/**** hook -------------------- */
onMounted(() => {
  setTodayStr();
});
onUpdated(() => {
  doOnStyle_qnb();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", {
          class: "logo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick_logo()))
        }, [
          _createVNode(_component_router_link, { to: { name: 'Main' } }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _hoisted_4,
        _createElementVNode("nav", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item, index) => {
            return (_openBlock(), _createElementBlock("ul", {
              class: _normalizeClass(["depth1", { active: index == _unref(menus)[0] }]),
              key: item
            }, [
              (index != 0)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: _normalizeClass([{ on: index == _unref(gnbStyles).indexOf(true) }]),
                    onClick: ($event: any) => (onClick_gnbDepth1(index))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(item.depth1.name), 1),
                    _createVNode(_Transition, { name: "gnbDepth2" }, {
                      default: _withCtx(() => [
                        (index == _unref(gnbStyles).indexOf(true) && _unref(isOn_gnb))
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.depth2, (subItem, subIndex) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: subItem,
                                  onClick: _withModifiers(($event: any) => (onClick_gnbDepth2(index, subIndex)), ["stop"])
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: { name: subItem.routerName }
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(subItem.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ], 8, _hoisted_8))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ], 10, _hoisted_6))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h2", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onClick_util()))
          }, "관리자"),
          _createVNode(_Transition, { name: "util" }, {
            default: _withCtx(() => [
              (_unref(isOn_util))
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_unref(isOn_auth))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: onClick_utilDepth2_1
                        }, _toDisplayString(_unref(utilDepth2_1)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      (_unref(isOn_gnb) || _unref(isOn_util))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "bg-dim",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (onClick_dimClear()))
          }, _hoisted_12))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("nav", {
          id: "qnb",
          class: _normalizeClass([{ on: _unref(isOn_scroll) }])
        }, [
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              to: { name: 'Main' },
              class: _normalizeClass([{ on: _unref(menus)[0] == 0 }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (onClick_qnbDepth1(0)))
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              to: { name: 'Doctor' },
              class: _normalizeClass([{ on: _unref(menus)[0] == 1 }]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (onClick_qnbDepth1(1)))
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              to: { name: 'Patient' },
              class: _normalizeClass([{ on: _unref(menus)[0] == 2 }]),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (onClick_qnbDepth1(2)))
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              to: { name: 'Appoint' },
              class: _normalizeClass([{ on: _unref(menus)[0] == 3 }]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (onClick_qnbDepth1(3)))
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              to: { name: 'Cost' },
              class: _normalizeClass([{ on: _unref(menus)[0] == 4 }]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (onClick_qnbDepth1(4)))
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              to: { name: 'Cs' },
              class: _normalizeClass([{ on: _unref(menus)[0] == 5 }]),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (onClick_qnbDepth1(5)))
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              to: { name: 'Setting' },
              class: _normalizeClass([{ on: _unref(menus)[0] == 6 }]),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (onClick_qnbDepth1(6)))
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ], 2),
        _hoisted_22,
        _createElementVNode("section", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            (_unref(menus)[0] == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", null, _toDisplayString(_unref(todayStr)), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _hoisted_28,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item, index) => {
                    return (_openBlock(), _createElementBlock("ul", {
                      class: "depth1",
                      key: item,
                      style: _normalizeStyle({ position: 'relative', left: _unref(leftNum), top: 0 })
                    }, [
                      (index != 0)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 0,
                            class: _normalizeClass([{ on: index == _unref(menus)[0] }])
                          }, [
                            _createElementVNode("span", _hoisted_29, _toDisplayString(item.depth1.name), 1),
                            (index == _unref(menus)[0])
                              ? (_openBlock(), _createElementBlock("ul", _hoisted_30, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.depth2, (subItem, subIndex) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      class: _normalizeClass([{ on: subIndex == _unref(menus)[1] }]),
                                      key: subItem,
                                      onClick: _withModifiers(($event: any) => (onClick_qnbDepth2(index, subIndex)), ["stop"])
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: { name: subItem.routerName }
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(subItem.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ], 10, _hoisted_31))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 4))
                  }), 128))
                ]))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["content-body", [{ 'shadow-on': _unref(bodyTitle) !== '대시보드' }]])
          }, [
            (_unref(bodyTitle) !== '대시보드')
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("h1", null, _toDisplayString(_unref(bodyTitle)), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(bodyDesc)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_router_view, null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view, { onOffLoadingLayer: offLoadingLayer })
                ]),
                _: 1
              })
            ])
          ], 2)
        ])
      ])
    ]),
    _hoisted_34,
    _createVNode(_Transition, { name: "loadingLayer" }, {
      default: _withCtx(() => [
        (_unref(isOn_loadingLayer))
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createVNode(LoadingLayer)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})